"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rawDisplay = void 0;
/**
 * A function that displays to console.log by default (for a REPL).
 *
 * @param value the value to be represented and displayed.
 * @param externalContext a property of Context that can hold
 *   any information required for external use (optional).
 */
function rawDisplay(str, prepend) {
    // tslint:disable-next-line:no-console
    console.log((prepend === undefined ? '' : prepend + ' ') + str);
}
exports.rawDisplay = rawDisplay;
//# sourceMappingURL=misc.js.map